import { Typography, styled, Box } from "@mui/material"

export const RibbonContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== "offset",
})(({ theme, offset = 35 }) => {
    const ribbonWidth =1.5*(offset+20); // tweak factor for desired look
    return ({
        backgroundColor: "green",
        position: "absolute",
        color: theme.palette.primary.contrastText,
        width: `${ribbonWidth}px`,
        zIndex: 3,
        textAlign: "center",
        padding: 3,
        "&::before": {
            position: "absolute",
            zIndex: -1,
            display: "block",
            border: "5px solid #2980b9",
        },
        "&::after": {
            position: "absolute",
            zIndex: -1,
            display: "block",
            border: "5px solid #2980b9",
        },
        transform: "rotate(-45deg)",
        transformOrigin: "bottom left",
        top: `${offset}px`,
        //left: -15,
    })
});

export const RibbonText = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "size",
})(({ theme, size = 16 }) => ({
    fontSize: `${size}px`,
    textAlign: 'center',
    whiteSpace : 'nowrap'
}));